// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-js.vjs-vtt-thumbnails{display:block}.video-js .vjs-vtt-thumbnail-display{bottom:85%;box-shadow:0 0 7px rgba(0,0,0,.6);pointer-events:none;position:absolute;transition:transform .1s,opacity .2s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
